import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import CriteriaField from '@components/EntityDrawers/components/CiaInputsGroup/CriteriaField';
import { isShownByDependency } from '@components/EntityDrawers/components/CiaInputsGroup/utils/helpers';
import { ISelectOption } from '@constants/entities/ui';
import { Stack, Typography } from '@mui/material';
import { CIASettingsCriteriaType } from '@store/services/questionnaire/types';
import {
  CriteriaKey,
  getCriteriaPath,
  resetDependentCriteria,
} from '@views/ProjectSettings/components/ProjectDetailsSettings/helpers/criteriaBlock.helpers';

type Props = {
  title: string;
  fields: CIASettingsCriteriaType[];
  criteriaKey: CriteriaKey;
  onChange?: (criteriaId: string, values: ISelectOption[]) => void;
};

const CriteriaBlock: FC<Props> = ({ title, fields, criteriaKey, onChange }) => {
  const { getValues, setValue } = useFormContext();

  const handleCriteriaChange = (id: string) => (values: ISelectOption[]) => {
    onChange?.(id, values);

    resetDependentCriteria(fields, id, values, criteriaKey, setValue);

    if (!values.length) {
      setValue(getCriteriaPath(criteriaKey, id), [], {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  };

  return (
    <Stack gap={4}>
      <Typography variant="h4">{title}</Typography>

      {fields.map((field) =>
        isShownByDependency(field.dependency, criteriaKey, getValues) ? (
          <CriteriaField
            key={field.id}
            field={field}
            nameKey={getCriteriaPath(criteriaKey, field.id)}
            changeHandler={handleCriteriaChange(field.id)}
          />
        ) : null,
      )}
    </Stack>
  );
};

export default CriteriaBlock;
